<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>

<template>
  <RouterLink
    to="/appointments"
    class="inline-flex items-center gap-2 text-sm text-muted hover:text-primary mb-4"
    data-testid="back-to-appointments"
  >
    <FontAwesomeIcon :icon="['fas', 'arrow-left']" />
    <span>Back to appointments</span>
  </RouterLink>
</template>
